import { isProd } from '@/config';
export var SET_NAVIGATION = 'set_navigation';
export var SET_MODULES = 'set_modules';
export var SET_BANNER_LIST = 'set_banner_list';
export var SET_SLOT_MAP = 'set_slot_map';
export var SET_ARTIST_LIST = 'set_artist_list';
export var SET_PROJECT_FLOOR_LIST = 'set_project_floor_list';
export var SET_GIANT = 'set_giant';
export var MUTATE_NAVIGATION_LIST = 'mutate_navigation_list';
export var MUTATE_CATEGORY_ID = 'mutate_category_id';
export var MUTATE_BANNER_LIST = 'mutate_banner_list';
export var MUTATE_ARTIST_LIST = 'mutate_artist_list';
export var MUTATE_MODULE_DATA = 'mutate_module_data';
export var MUTATE_CATEGORY_DATA = 'mutate_category_data';
export var MUTATE_CLEAR_CATEGORY_DATA = 'mutate_clear_category_data';
export var positionMap = {
  1: 1274,
  // 演唱会
  2: 1281,
  // 体育赛事
  3: 1282,
  // 戏曲艺术
  4: 1279,
  // 话剧歌剧
  5: 1283,
  // 舞蹈芭蕾
  6: 1285,
  // 音乐会
  7: 1284,
  // 亲子
  8: 1286,
  // 更多精彩
  9: 1280,
  // 休闲展览
  10: 1278,
  // 音乐节
  14: 1401,
  // 沉浸式剧场
  15: isProd ? 1417 : 1623,
  // 脱口秀,
  16: isProd ? 1418 : 1624,
  // 相声
  11: 2026,
  // 演出直播
  13: 2025,
  // 剧本杀
  12: 2024,
  // 电竞赛事
  17: 2557 // Livehouse
};

export var idMapName = {
  1: 'swiper',
  // 改版前使用
  2: 'banner',
  3: 'offers',
  // 改版前使用
  4: 'goodReads',
  // 改版前使用
  5: 'brandPavilion',
  // 改版前使用
  6: 'artistBigShot',
  // 艺人大咖
  7: 'mustSee',
  // 改版前使用
  8: 'giant',
  // 巨无霸
  9: 'projectFloor',
  // 项目楼层
  10: 'newBrand' // 新品牌馆
};